/* eslint-disable max-lines*/
/* eslint-disable max-len */
import { observer } from 'mobx-react';
import React, { Suspense, lazy } from 'react';
import { DocumentWrapper } from '../documentWrapper';
import { NAVIGATION } from 'constants/navigation';
import './documentTileStyles.scss';
import AppStore from 'container/app/appStore';
import { action, observable } from 'mobx';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { DbFolderContainerStore } from '../dbFolderContainerStore';
import { DocumentSearchStore } from 'pages/search/documentSearchStore';
import LoadingSpinner from 'components/loadingSpinner/loadingSpinner';
import { EXTERNAL_LINKS } from 'constants/ExternalLinks';
import { Document } from 'api/document';
import { getFolderMetadata } from 'api/graphql/query';
import { Folder } from 'api/folder';
import CopyButton from 'pages/document/components/content/sectionLinkCopyIcon';
import MyOrganization from 'components/myOrganization/myOrganization';
import Badge from '@amzn/awsui-components-react/polaris/badge';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Header from '@amzn/awsui-components-react/polaris/header';
import Link from '@amzn/awsui-components-react/polaris/link';
import Icon from '@amzn/awsui-components-react/polaris/icon';
import TextContent from '@amzn/awsui-components-react/polaris/text-content';
import ExpandableSection from '@amzn/awsui-components-react/polaris/expandable-section';
import Button from '@amzn/awsui-components-react/polaris/button';
import Box from '@amzn/awsui-components-react/polaris/box';
import Toggle from '@amzn/awsui-components-react/polaris/toggle';
import Popover from '@amzn/awsui-components-react/polaris/popover';
import Input from '@amzn/awsui-components-react/polaris/input';
import Grid from '@amzn/awsui-components-react/polaris/grid';
import Checkbox from '@amzn/awsui-components-react/polaris/checkbox';
import Pagination from '@amzn/awsui-components-react/polaris/pagination';
import Select from '@amzn/awsui-components-react/polaris/select';
import { 
  Table
} from '@amzn/awsui-components-react';
import { DocItem } from './documentInterface';
const Favorites = lazy(() => import('components/favorites/favorites'));

interface Props {
  appStore?: AppStore;
  documentWrapper: DocumentWrapper;
  dbFolderContainerStore?: DbFolderContainerStore;
  documentSearchStore?: DocumentSearchStore;
  isSearch?: boolean;
  favoritesStore?;
  myOrganizationStore?;
  isLoading?: boolean;
  isLandingPage?: boolean;
  setIsLoadingDocuments?: (isLoading: boolean) => void;
  onSelectedChange?: (folder: Folder) => void;
  setActiveFolderHref?: (href: string) => void;
}

export enum DocumentTypes {
  POLICY = 'POLICY',
  PROCEDURE = 'PROCEDURE',
  GUIDELINE = 'GUIDELINE',
  STANDARD = 'STANDARD',
  TRANSCLUDE = 'TRANSCLUDE',
  OTHER = 'OTHER'
}


const docTypes = ['POLICY', 'PROCEDURE', 'STANDARD', 'GUIDELINE', 'TRANSCLUDE', 'OTHER'];

@observer
export class DocumentTile extends React.PureComponent<Props, any> {
  constructor(props) {
    super(props);
    this.state = {
      organizedData: {},
      showAll: false,
    };
  }

  toggleShowAll = () => {
    this.setState(prevState => ({ showAll: !prevState.showAll }));
  };

  // @observable isRelated: boolean
  @observable searchText = '';
  @observable documentTypesSelected: string[] = docTypes;
  @observable expandedTagDocs: Set<string> = new Set();
  @observable filterAllCheckboxEnabled = true;
  @observable filterPolicyCheckboxEnabled = true;
  @observable filterProcedureCheckboxEnabled = true;
  @observable filterGuidelineCheckboxEnabled = true;
  @observable filterStandardCheckboxEnabled = true;
  @observable filterTranscludeCheckboxEnabled = true;
  @observable filterOtherCheckboxEnabled = true;


  isDraftBadge(document: any): string {
    if (document.entityType === 'folder') return 'Folder';
    if (document.version !== 0) {
      return 'publication';
    }
    return 'draft';
  }

  @action
  componentDidUpdate(prevProps) {
    const { documentWrapper: prevDocumentWrapper } = prevProps;
    const { documentWrapper } = this.props;
    if (documentWrapper?.selectedFolder?.id !== prevDocumentWrapper?.selectedFolder?.id) {
      this.searchText = '';
      this.filterAllCheckboxEnabled = true;
      this.handleAllCheckboxClick(true);
      this.documentTypesSelected = docTypes;
      this.expandedTagDocs.clear();
    }
  }

  getFolders(): void {
    const { appStore, documentWrapper, dbFolderContainerStore } = this.props;
    dbFolderContainerStore?.getFilesUnderFolder(
      documentWrapper!.selectedFolder!.id,
      appStore!.paginationPageNumber,
      parseInt(appStore!.paginationPageSize.value || '10'),
      this.searchText ?? '',
      this.documentTypesSelected
    );
  }
  //
  @action.bound
  handleAllCheckboxClick(detail) {
    this.filterPolicyCheckboxEnabled = detail;
    this.filterProcedureCheckboxEnabled = detail;
    this.filterGuidelineCheckboxEnabled = detail;
    this.filterOtherCheckboxEnabled = detail;
    this.filterStandardCheckboxEnabled = detail;
    this.filterTranscludeCheckboxEnabled = detail;
  }

  @action
  handleCheckboxChange = (documentType, checked, folderId) => {
    if (checked) {
      this.documentTypesSelected.push(documentType);
    } else {
      this.documentTypesSelected = this.documentTypesSelected.filter(item => item !== documentType);
    }
    if (!checked) {
      this.filterAllCheckboxEnabled = checked;
    }
    this.handleAllCheckbox();
    this.searchDocuments(folderId);
  };

  @action.bound
  handleAllCheckbox() {
    if (this.documentTypesSelected.length === docTypes.length) {
      this.filterAllCheckboxEnabled = true;
    }
  }

  // Execute a new search when pagination settings change.
  runSearch(): void {
    const { documentSearchStore } = this.props;
    documentSearchStore?.onSearch();
  }

  @action.bound
  handleEditClick() {
    const { appStore, documentWrapper } = this.props;
    appStore!.navigateTo(NAVIGATION.FOLDER_MANAGEMENT_PAGE.LINK(documentWrapper.selectedFolder?.id));
  }

  @action.bound
  handleTagClick(tagValue: string) {
    const { documentSearchStore } = this.props;
    if (!documentSearchStore) return;
    // OR accumulate: add tag to the list — backend uses terms query
    // (matches docs with ANY of these tags, AND'd with other search filters)
    const currentTagFilters = documentSearchStore.refinedFilters['tagFilter'] || [];
    if (!currentTagFilters.includes(tagValue)) {
      documentSearchStore.refinedFilters['tagFilter'] = [...currentTagFilters, tagValue];
      documentSearchStore.onSearch(true);
    }
  }

  @action.bound
  toggleTagExpansion(documentId: string) {
    if (this.expandedTagDocs.has(documentId)) {
      this.expandedTagDocs.delete(documentId);
    } else {
      this.expandedTagDocs.add(documentId);
    }
  }

  /**
   * Handles click on any favorited folders.
   * @param {Document} folder The folder that was clicked on.
   */
  handleFavoriteFolderClick(folder: Document): void {
    const { dbFolderContainerStore, onSelectedChange, appStore, setIsLoadingDocuments, setActiveFolderHref } = this.props;
    const [folderId] = folder.id.toString().split('/');
    if (setIsLoadingDocuments) setIsLoadingDocuments(true);

    appStore?.api.query(getFolderMetadata, { folderId })
      .then(action(value => {
        const path: string[] = [];
        // this.props.appStore?.isRelated = value.data?.getFolderMetadata?.isRelated
        const selected = new Folder(value.data?.getFolderMetadata);
        selected?.parentFolders?.forEach(element => {
          path.unshift(element.id);
        });
        path.unshift(folderId);
        dbFolderContainerStore?.performFolderSelect('', path);
        if (onSelectedChange) onSelectedChange(selected);
        // Set folder to be active and redirect to org view
        if (this.props.isLandingPage) {
          if (setActiveFolderHref) setActiveFolderHref(`#folderId=${path.reverse().join('/')}`);
          appStore!.navigateTo(NAVIGATION.LANDING_PAGE.LINK(path.reverse().join('/')));
        } else {
          const activeHref = path.reverse().join('/');
          if (setActiveFolderHref) setActiveFolderHref(activeHref);
          // If favorite folder alias defined, redirect to pretty URL
          if (selected.folderAlias && selected.folderAlias.length > 0) appStore!.navigateTo(NAVIGATION.DASHBOARD_PAGE.ALIAS_LINK(selected.folderAlias));
          else appStore!.navigateTo(NAVIGATION.DASHBOARD_PAGE.LINK(activeHref));
        }
      }))
      .catch(e => this.props.appStore?.onError(e))
      .finally(() => {
        if (setIsLoadingDocuments) setIsLoadingDocuments(false);
      });
  }

  getRedirectUrl(document) {
    const isInTakeForm = ['EXCEPTION_REQUEST', 'EXTENSION_REQUEST', 'CLOSURE_REQUEST', 'INTAKE_FORM', 'EXTENSION_FORM', 'CLOSURE_FORM'].includes(document.documentType);
    const draftBadge = this.isDraftBadge(document);
    if (isInTakeForm) return NAVIGATION.INTAKE_FORM_PAGE.LINK(document.id, draftBadge);
    if (document.supplementalTag && document.supplementalTag.length && document.supplementalTag !== 'Global') return NAVIGATION.EXISTING_SUPPLEMENTAL_PAGE.LINK(document.id, document.supplementalTag);
    return NAVIGATION.DOCUMENT_PAGE.LINK(document.id, draftBadge);
  }


  renderFileHeader(document: any) {
    const { documentWrapper: { selectedFolder } } = this.props;
    const draftBadge = this.isDraftBadge(document);
    const isFavoritesFolder: boolean = selectedFolder?.id === 'FAVORITES';
    const isDocument = document.entityType === 'document';


    return (
      <Header
        className="policy--document-title-margin"
        actions={
          <SpaceBetween direction="horizontal" size="xxs">
            {document.isTemplate && <Badge color="grey">Template</Badge>}
            <Badge color="grey"> {document.documentType} </Badge>
            <Badge color="grey">{draftBadge}</Badge>
            {isFavoritesFolder && isDocument && <Badge color="grey">DOCUMENT</Badge>}
            {document.metaData?.underReview &&
              <Badge color="red">Under Review</Badge>
            }
            {document.metaData?.underBulkReview &&
              <Badge color="red">Under Bulk Review</Badge>
            }
            {!selectedFolder && document?.metaData?.parentFolderId && document?.metaData?.parentFolderName &&
              <Link
                variant="secondary"
                href={NAVIGATION.FOLDER_MANAGEMENT_PAGE.LINK(document?.metaData?.parentFolderId)}
                target="_blank" className="policy--document-link-icon" >
                <Badge color="grey">
                  <Icon name="folder-open" />&nbsp;&nbsp;{document?.metaData?.parentFolderName}
                </Badge>
              </Link>
            }
            {document.tags && document.tags.length > 0 && (() => {
              const TAG_DISPLAY_LIMIT = 5;
              const isExpanded = this.expandedTagDocs.has(document.id);
              const visibleTags = isExpanded ? document.tags : document.tags.slice(0, TAG_DISPLAY_LIMIT);
              const remainingCount = document.tags.length - TAG_DISPLAY_LIMIT;
              const { documentSearchStore } = this.props;

              return (
                <>
                  {visibleTags.map((tag, index) => {
                    if (documentSearchStore) {
                      return (
                        <span
                          key={`tag-${index}-${tag}`}
                          data-testid={`search-tag-clickable-${index}`}
                          className="policy--tag-clickable"
                          role="button"
                          tabIndex={0}
                          aria-label={`Filter by tag: ${tag}`}
                          onClick={() => this.handleTagClick(tag)}
                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.handleTagClick(tag); } }}
                        >
                          <Badge color="blue">{tag}</Badge>
                        </span>
                      );
                    }
                    return (
                      <span key={`tag-${index}-${tag}`} data-testid={`search-tag-badge-${index}`}>
                        <Badge color="blue">{tag}</Badge>
                      </span>
                    );
                  })}
                  {!isExpanded && remainingCount > 0 && (
                    <span
                      className="policy--tag-overflow-link"
                      role="button"
                      tabIndex={0}
                      aria-label={`Show ${remainingCount} more tags`}
                      data-testid={`search-tag-show-more-${document.id}`}
                      onClick={() => this.toggleTagExpansion(document.id)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleTagExpansion(document.id); } }}
                    >
                      +{remainingCount} more
                    </span>
                  )}
                  {isExpanded && remainingCount > 0 && (
                    <span
                      className="policy--tag-overflow-link"
                      role="button"
                      tabIndex={0}
                      aria-label="Show fewer tags"
                      data-testid={`search-tag-show-less-${document.id}`}
                      onClick={() => this.toggleTagExpansion(document.id)}
                      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.toggleTagExpansion(document.id); } }}
                    >
                      Show less
                    </span>
                  )}
                </>
              );
            })()
            }
          </SpaceBetween>
        }
      >

        {document?.entityType === 'folder' ?
          // Used for rendering folders on the Favorites page since a redirect is not needed.
          <TextContent>
            <h3>
              <a onClick={() => this.handleFavoriteFolderClick(document)} className="policy--document-detail-title">
                {document.title}&nbsp;
              </a>
            </h3>
          </TextContent>
          :
          <SpaceBetween size="xxs">
            <Link
              variant="secondary"
              external
              href={this.getRedirectUrl(document)}
              target="_blank"
              className="policy--document-link-icon"
            >
              <span className="policy--document-detail-title">
                {document.title}&nbsp; 
              </span>
            </Link>
          </SpaceBetween>
        }
      </Header>
    );
  }

  generateCorrectTitle(title) {
    if (title) {
      return title;
    }
    return 'No Title';
  }

  

  generateExternalUrl(item) {
    if (item.Link?.includes('https://')) {
      return item.Link;
    }
    return `https://${item.Link}`;
  }

  // this will take a list of domain and parent child relationships
  /**
 * Renders either:
 *  • a flat list of links (Domain/Related), or
 *  • a 4-column Parent/Child table if `paths` is provided
 */


  DocumentSection = ({
    items = [],
    displayedItems = [],
    paths,
    sectionTitle,
    isInTakeForm,
    document,
    draftBadge,
    showAll,
    toggleShowAll,
  }: {
    items?: DocItem[];
    displayedItems?: DocItem[];
    paths?: DocItem[][];
    sectionTitle: string;
    isInTakeForm: boolean;
    document: any;
    draftBadge: string;
    showAll: boolean;
    toggleShowAll: () => void;
  }) => {
    if ((!items || items.length === 0) && (!paths || paths.length === 0)) return null;
  
    const count = new Set(paths?.flatMap(p => p.map(d => d.documentId)) ?? []).size;
    const itemsToShow = showAll ? items! : displayedItems!;
  
    /*--------------------------------------------
      BUILD BUCKETS  (parent → children → grands)
    ---------------------------------------------*/
    if (paths && paths.length) {
      const uniquePaths = Array.from(
        new Map(paths.map(p => [p.map(d => d.documentId).join('|'), p])).values()
      );
  
      interface Bucket {
        parent: DocItem;
        children: { node: DocItem; grandchildren: DocItem[] }[];
      }
      const buckets: Record<string, Bucket> = {};
  
      uniquePaths.forEach(p => {
        const [_, lvl1, lvl2, lvl3] = p; // ignore p[0] (root)
        if (!lvl1) return;
        if (!buckets[lvl1.documentId]) {
          buckets[lvl1.documentId] = { parent: lvl1, children: [] };
        }
        if (lvl2) {
          let entry = buckets[lvl1.documentId].children.find(
            c => c.node.documentId === lvl2.documentId
          );
          if (!entry) {
            entry = { node: lvl2, grandchildren: [] };
            buckets[lvl1.documentId].children.push(entry);
          }
          // only add if not already present
          if (lvl3 && !entry.grandchildren.some(g => g.documentId === lvl3.documentId)) {
            entry.grandchildren.push(lvl3);
          }
        }
      });
  
      const rows: any[] = [];
      let isFirstParent = true;
  
      Object.values(buckets).forEach(bucket => {
        const divider = !isFirstParent;
        isFirstParent = false;
  
        const parentCell = (
          <div style={{ borderTop: divider ? '1px solid var(--color-border)' : 'none' }}>
            <Link
              key={bucket.parent.documentId}
              href={
                isInTakeForm
                  ? NAVIGATION.INTAKE_FORM_PAGE.LINK(bucket.parent.documentId.split('-').pop(), draftBadge)
                  : NAVIGATION.DOCUMENT_PAGE.LINK(bucket.parent.documentId.split('-').pop(), draftBadge)
              }
            >
              <span title={bucket.parent.Title || 'No Title'}>
                {bucket.parent.Title || 'No Title'}
              </span>
            </Link>
          </div>
        );
  
        if (bucket.children.length === 0) {
          rows.push({ level1: parentCell });
          return;
        }
  
        bucket.children.forEach((child, idx) => {
          const childCell = (
            <Box margin={{ right: 'xl' }}>
              <Link
                key={child.node.documentId}
                href={
                  isInTakeForm
                    ? NAVIGATION.INTAKE_FORM_PAGE.LINK(child.node.documentId.split('-').pop(), draftBadge)
                    : NAVIGATION.DOCUMENT_PAGE.LINK(child.node.documentId.split('-').pop(), draftBadge)
                }
              >
                {child.node.Title}
              </Link>
            </Box>
          );
  
          const grandchildCell = child.grandchildren.length > 0 ? (
            <SpaceBetween size="s" direction="vertical">
              {child.grandchildren.map(g => (
                <Link
                  key={g.documentId}
                  href={
                    isInTakeForm
                      ? NAVIGATION.INTAKE_FORM_PAGE.LINK(g.documentId.split('-').pop(), draftBadge)
                      : NAVIGATION.DOCUMENT_PAGE.LINK(g.documentId.split('-').pop(), draftBadge)
                  }
                >
                  {g.Title}
                </Link>
              ))}
            </SpaceBetween>
          ) : null;
  
          rows.push({
            level1: idx === 0 ? parentCell : null,
            level2: childCell,
            level3: grandchildCell,
          });
        });
      });
  
      /*---------------------------------
        RENDER TABLE
      ---------------------------------*/
      return (
        <ExpandableSection headerText={
          <span className="small-header">
            {sectionTitle} <span className="count">({count})</span>
          </span>
        } defaultExpanded className="expandable-section-styles">
          <Table
            variant="borderless"
            wrapLines={false}
            className="fixed-layout-table tree-table top-align"
            columnDefinitions={[
              { id: 'l1', header: '1st lv.',cell: r => (
                <div
                  style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  {r.level1}
                </div>
              ), width: '32%' },
              { id: 'l2', header: '2nd lv.', cell: r => (
                <div
                  style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  {r.level2}
                </div>
              ), width: '32%' },
              { id: 'l3', header: '3rd lv.', cell: r => (
                <div
                  style={{
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                  }}
                >
                  {r.level3}
                </div>
              ), width: '31%' },
            ]}
            items={rows}
          />
        </ExpandableSection>
      );
    }
  
    /*---------------------------------
      FALLBACK (no paths)
    ---------------------------------*/
    return (
      <ExpandableSection 
      headerText={
        <span className="small-header">
          {sectionTitle} <span className="count">({itemsToShow.length})</span>
        </span>
      }
      defaultExpanded className="expandable-section-styles">
        <SpaceBetween size="s" direction="vertical">
          <SpaceBetween size="s" direction="horizontal">
            {itemsToShow.map((item, idx) => (
              <div
                key={item.documentId.split('-').pop()}
                className={`link-container ${idx < itemsToShow.length - 1 ? 'link-with-divider' : ''}`}
              >
                {item.entityType === 'EXTERNAL' ? (
                  <Link external href={this.generateExternalUrl(item)}>
                    {item.Title}
                  </Link>
                ) : (
                  <Link
                    href={
                      isInTakeForm
                        ? NAVIGATION.INTAKE_FORM_PAGE.LINK(item.documentId.split('-').pop(), draftBadge)
                        : NAVIGATION.DOCUMENT_PAGE.LINK(item.documentId.split('-').pop(), draftBadge)
                    }
                  >
                    <span title={item.Title || 'No Title'}>{item.Title}</span>
                  </Link>
                )}
              </div>
            ))}
          </SpaceBetween>
          {items.length > 20 && (
            <Box textAlign="center">
              <Button variant="link" onClick={toggleShowAll}>
                {showAll ? 'View Less' : 'View All'}
              </Button>
            </Box>
          )}
        </SpaceBetween>
      </ExpandableSection>
    );
  };
  
  
  /* -------------
     CSS OVERRIDE
     Add to your SCSS / CSS module so only parent rows get a divider.
  -------------*/
  /*
  .no-row-borders .awsui_table-row > .awsui_table-cell {
    border-bottom: none !important;
  }
  
  .no-row-borders .awsui_table-row:first-of-type > .awsui_table-cell {
    border-top: 1px solid var(--color-border); // optional first row divider
  }
  */
  
  
  @action.bound
  setSearchText(value) {
    this.searchText = value.toLowerCase();
  }

  @action.bound
  searchDocuments(folderId) {
    this.props.dbFolderContainerStore?.getFilesUnderFolder(folderId, 1, 10, this.searchText, this.documentTypesSelected);
  }


  renderDocumentDetail(
    document,
    isRelated,
    domain,
    related,
    parentItems
  ) {
    const draftBadge  = this.isDraftBadge(document);
    const isInTakeForm = [
      'EXCEPTION_REQUEST','EXTENSION_REQUEST','CLOSURE_REQUEST',
      'INTAKE_FORM','EXTENSION_FORM','CLOSURE_FORM'
    ].includes(document.documentType);
  
    const shortId = document.id?.split('-').pop() ?? '';
    if (!document.id) return null;
  
    const domainItems = domain?.[shortId]  ?? []
    const domainDisplayedItems  = domainItems.slice(0, 20);
    const relatedItems          = related?.[shortId] ?? [];
    const relatedDisplayedItems = relatedItems.slice(0, 20);
  
    const parentGroup = parentItems?.find?.(g => g.id === shortId);
    const parentPaths = parentGroup?.paths ?? [];
    const domainPaths: DocItem[][] = domainItems.map(item => [ document, item ]);
    const isChildInAnyPath = parentPaths.some(path =>
      path.slice(1).some(p => {
        const docId = p.documentId.split('-').pop()!;
        return docId === shortId;
      })
    );
    if (isChildInAnyPath) return null;
    return (
      <Box key={document.id} className="policy--document-row-layout">
        <Box className="policy--document-item-layout">
          {this.renderFileHeader(document)}
  
          <Box>
            <span className="policy--document-attributes">
              <p>{document.description}</p>
            </span>
          </Box>
  
          {document.documentType && isRelated && (
            <>
              {this.DocumentSection({
                paths:           [...parentPaths, ...domainPaths],
                displayedItems:  domainDisplayedItems,
                sectionTitle:    'Domain Documents',
                isInTakeForm,
                document,
                draftBadge,
                showAll:         this.state.showAll,
                toggleShowAll:   this.toggleShowAll,
              })}
  
              {this.DocumentSection({
                items:           relatedItems,
                displayedItems:  relatedDisplayedItems,
                sectionTitle:    'Reference Documents',
                isInTakeForm,
                document,
                draftBadge,
                showAll:         this.state.showAll,
                toggleShowAll:   this.toggleShowAll,
              })}
            </>
          )}
        </Box>
      </Box>
    );
  }
  

  renderHeaderDescription(metaData: any): JSX.Element {
    let message;

    if (metaData?.description) {
      message = metaData.description;
    } else if (metaData?.isAdmin) {
      message = 'Click the Manage button to move, rename, or update permisions, approvals, and templates on this folder.';
    } else {
      message = 'Please click the View button to see this folder\'s permissions, approvals, and custom process templates.';
    }

    return (
      <TextContent>
        {message}
      </TextContent>
    );
  }

  renderCheckBox(folderId) {
    return (
      <section className="align-center">
        <Toggle
          onChange={action(({ detail }) => {
            this.props.dbFolderContainerStore?.setIncludeSubFolder(detail.checked);
            this.searchText ? this.props.dbFolderContainerStore?.getFilesUnderFolder(folderId, 1, 10, this.searchText) : this.props.dbFolderContainerStore?.getFilesUnderFolder(folderId);
          })}
          checked={this.props.dbFolderContainerStore?.includeSubFolders || false}
          data-testid="dashboard-subfolder-toggle"
        >
          <span className="policy--document-checkbox">Show subfolders</span>
        </Toggle>
      </section>
    );
  }

  renderManageButton(metaData) {
    if (metaData?.isAdmin) {
      return (
        <Button iconAlign="left" iconName="unlocked" variant="primary" target="_blank" onClick={this.handleEditClick} data-testid="dashboard-manage-button" >
          Manage
        </Button>
      );
    } else if (metaData?.canRead) {
      return (
        <Button iconAlign="left" iconName="lock-private" variant="normal" target="_blank" onClick={this.handleEditClick} data-testid="dashboard-view-button" >
          View
        </Button>
      );
    } else {
      return (
        <Button iconAlign="left" iconName="lock-private" variant="normal" target="_blank" onClick={this.handleEditClick} >
          Access Denied
        </Button>
      );
    }
  }

  renderManageFolderHelp(metaData) {
    if (metaData?.isAdmin) {
      return (
        <section className="align-center policy--icon-help-marigin">
          <Popover
            className="policy--permission-help-popover"
            position="bottom" size="medium" triggerType="custom" content={
              <div className="policy--dashboard-popover">
                Folder Settings
                <hr />
                <p className="policy--tool-tip-description">
                  Please click &quot;Manage&quot; button to move or rename this folder and update folder permisions,
                  approval and business process templates defined for this folder. Also
                  refer
                  <Link
                    className="policy--dashboard-popover-link"
                    href={EXTERNAL_LINKS.FOLDER_MANAGEMENT_HELP}
                    target="_blank"
                  >
                    user guide
                    <Icon name="external" />
                  </Link>
                  for more details.
                </p>
              </div>
            }>
            <InfoOutlined className="policy--icon-help align-center" />
          </Popover>
        </section>
      );
    } else {
      return (
        <section className="align-center policy--icon-help-marigin">
          <Popover
            className="policy--permission-help-popover"
            position="bottom" size="medium" triggerType="custom" content={
              <div className="policy--dashboard-popover">
                Folder Settings
                <hr />
                <p className="policy--tool-tip-description">
                  You have the view permission and please click &apos;View&apos; to find folder owners or
                  refer <Link className="policy--dashboard-popover-link" href={EXTERNAL_LINKS.FOLDER_MANAGEMENT_HELP} target="_blank">user guide <Icon name="external" /></Link> for more details.
                </p>
              </div>
            }>
            <InfoOutlined className="policy--icon-help align-center" />
          </Popover>
        </section>
      );
    }
  }

  renderSearchAndFilters(): any {
    const { documentWrapper: { selectedFolder } } = this.props;
    const isFavoritesFolder: boolean = selectedFolder?.id === 'FAVORITES';
    return (
      <Grid disableGutters gridDefinition={[{ colspan: 11 }, { colspan: 1 }]}>
        {!isFavoritesFolder &&
          <section>
            <div data-testid="dashboard-search-input">
            <Input
              type="search"
              placeholder="Search keywords or document titles in the current folder"
              value={this.searchText}
              onKeyDown={e => {
                if (e.detail.key === 'Enter') {
                  this.searchDocuments(selectedFolder?.id);
                }
              }}
              onChange={detail => {
                this.setSearchText(detail?.detail?.value);
              }}
            />
            </div>
          </section>
        }
        {!isFavoritesFolder &&
          <section className="policy--folder-search">
            <Button iconName="search" variant="primary" onClick={() => this.searchDocuments(selectedFolder?.id)} data-testid="dashboard-search-button" />
          </section>
        }
        {!isFavoritesFolder &&
          <section className="policy--folder-search-filters" data-testid="dashboard-filter-section">
            <SpaceBetween direction="horizontal" size="xs">
              <Checkbox
                onChange={action(({ detail }) => {
                  if (detail?.checked) {
                    this.documentTypesSelected = ['POLICY', 'PROCEDURE', 'STANDARD', 'GUIDELINE', 'TRANSCLUDE', 'OTHER'];
                  } else {
                    this.documentTypesSelected = [];
                  }
                  this.filterAllCheckboxEnabled = detail?.checked;
                  this.handleAllCheckboxClick(detail?.checked);
                  this.searchDocuments(selectedFolder?.id);
                })}
                checked={this.filterAllCheckboxEnabled}
                data-testid="dashboard-filter-all" >
                All
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.POLICY, detail?.checked, selectedFolder?.id);
                  this.filterPolicyCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterPolicyCheckboxEnabled} >
                Policies
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.STANDARD, detail?.checked, selectedFolder?.id);
                  this.filterStandardCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterStandardCheckboxEnabled} >
                Standards
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.PROCEDURE, detail?.checked, selectedFolder?.id);
                  this.filterProcedureCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterProcedureCheckboxEnabled} >
                Procedures
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.GUIDELINE, detail?.checked, selectedFolder?.id);
                  this.filterGuidelineCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterGuidelineCheckboxEnabled} >
                Guidelines
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.TRANSCLUDE, detail?.checked, selectedFolder?.id);
                  this.filterTranscludeCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterTranscludeCheckboxEnabled} >
                Transcludes
              </Checkbox>

              <Checkbox
                onChange={action(({ detail }) => {
                  this.handleCheckboxChange(DocumentTypes.OTHER, detail?.checked, selectedFolder?.id);
                  this.filterOtherCheckboxEnabled = detail?.checked;
                })}
                checked={this.filterOtherCheckboxEnabled} >
                Other
              </Checkbox>
            </SpaceBetween>
          </section>
        }
      </Grid>
    );
  }

  renderFolderHeader(): any {
    const { appStore, dbFolderContainerStore, favoritesStore, myOrganizationStore } = this.props;
    const totalItems: number = this.props.documentWrapper?.documentMetadata?.totalItems ?? null;
    const isFavoritesFolder: boolean = dbFolderContainerStore?.selectedFolder?.id === 'FAVORITES';

    return !dbFolderContainerStore?.selectedFolder ? (
      <TextContent><p>{totalItems} items found</p></TextContent>
    ) : (
      <Header
        variant="h3"
        description={this.renderHeaderDescription(dbFolderContainerStore?.selectedFolder?.metaData)}
        actions={
          <>
            {/* The Favorites folder should not have a Manage button. */}
            {!isFavoritesFolder && (
              <section id="policy--box-header-actions-section">
                <SpaceBetween direction="horizontal" size="xs">
                  {this.renderCheckBox(dbFolderContainerStore?.selectedFolder?.id)}
                  {this.renderManageFolderHelp(dbFolderContainerStore?.selectedFolder?.metaData)}
                  <section className="align-center">
                    <CopyButton icon="copy" type="Button" folderAlias={dbFolderContainerStore?.selectedFolder.folderAlias} />
                  </section>
                  {this.renderManageButton(dbFolderContainerStore?.selectedFolder?.metaData)}
                </SpaceBetween>
              </section>
            )}
          </>
        }
      >
        <Grid disableGutters gridDefinition={[{ colspan: 12 }, { colspan: 12 }]}>
          <TextContent>
            <SpaceBetween direction="vertical" size="xs">
              <section id="policy--box-header-section">
                <span className="policy--box-header">
                  <SpaceBetween direction="horizontal" size="xs">
                    <section style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <Icon className="policy--folder-dashboard-icon" id="folder-icon" name="folder-open" size="medium" />
                      <h2>{dbFolderContainerStore?.selectedFolder?.folderName} ({(totalItems < 10000) ? totalItems : `${totalItems}+`})</h2>
                    </section>
                    {/* Show the favorite icon next all folders except for the actual Favorites folder. */}
                    {appStore?.favoritesFeatureEnabled && !isFavoritesFolder && dbFolderContainerStore?.favoritesStore && (
                      <Suspense fallback={<></>}>
                        <Favorites store={favoritesStore} onClick={isFavorited => dbFolderContainerStore.handleFavoritesClick(isFavorited)} />
                      </Suspense>
                    )}
                    {myOrganizationStore && !isFavoritesFolder && (
                      <Suspense fallback={<></>}>
                        <MyOrganization store={myOrganizationStore} entityId={dbFolderContainerStore?.selectedFolder?.id} />
                      </Suspense>
                    )}
                  </SpaceBetween>
                </span>
              </section>
            </SpaceBetween>
          </TextContent>
        </Grid>
      </Header>
    );
  }

  render() {
    const { documentWrapper, appStore, isSearch, isLoading } = this.props;
    const isFavoritesFolder: boolean = documentWrapper.selectedFolder?.id === 'FAVORITES';

    // if the documents are loading, show spinner
    if (isLoading) {
      return <LoadingSpinner size="big" message="Loading documents..." absoluteCenter />;
    }

    // if there are no documents, then show no documents message
    if (!documentWrapper.documents) {
      return (
        <TextContent>
          <div className="policy--document-none">
            <br />
            <div className="policy--document-none-message">
              <div style={{ flex: 0.1, height: 1, backgroundColor: '#ff9900' }} />
              <Icon className="policy--document-icon-warning" id="folder-icon" name="folder-open" size="large" />
              <div style={{ flex: 0.1, height: 1, backgroundColor: '#ff9900' }} />
            </div>
            <p className="policy--document-none-message-next">
              Please select a folder on the left to see its contents here.
            </p>
          </div>
        </TextContent>
      );
    }
    if (documentWrapper.documents.length === 0) {
      return (
        <>
          {this.renderFolderHeader()}
          {!isSearch ? this.renderSearchAndFilters() : null}
          <div className="policy--document-none">
            <br />
            <div className="policy--document-none-message">
              <div style={{ flex: 0.1, height: 1, backgroundColor: '#ff9900' }} />
              <Icon className="policy--document-icon-warning" id="folder-icon" name="folder-open" size="large" />
              <div style={{ flex: 0.1, height: 1, backgroundColor: '#ff9900' }} />
            </div>
            <p className="policy--document-none-message"> There is no information to display here because the folder you selected does not have any documents.</p>
          </div>
        </>
      );
    }

    // Return all document details
    const parentItems = this.props.dbFolderContainerStore?.parentItems || [];
    const allChildDocIds = new Set<string>();

    parentItems.forEach(group => {
      (group.paths || []).forEach(path => {
        path.slice(1).forEach(p => {
          const shortId = p.documentId?.split('-').pop();
          if (shortId) {
            allChildDocIds.add(shortId);
          }
        });
      });
    });
    return (

      <section style={{ height: '100%' }}>
        <SpaceBetween direction="vertical" size="xs">
          {this.renderFolderHeader()}
          {!isSearch ? this.renderSearchAndFilters() : null}
        </SpaceBetween>
        <section id="policy--document-pagination-documents-section" data-testid="dashboard-document-list" style={{ height: `${isSearch ? '65vh' : '72vh'}` }}>
        {documentWrapper?.documents
          .filter(document => {
            if (!this.props.appStore?.isRelated) return true;
            return !allChildDocIds.has(document.id.split('-').pop()!);
          })
          .map(document =>
            this.renderDocumentDetail(
              document,
              this.props.appStore?.isRelated,
              this.props.dbFolderContainerStore?.domainItems,
              this.props.dbFolderContainerStore?.relatedItems,
              this.props.dbFolderContainerStore?.parentItems
            )
          )}
        </section>

        <section id="policy--document-pagination-controls-section" data-testid="dashboard-pagination-section">
          <Grid
            gridDefinition={[
              { colspan: 10 },
              { colspan: 2 },
            ]}
          >
            <SpaceBetween direction="vertical" size="xl">
              <span />
              <Pagination
                ariaLabels={{
                  nextPageLabel: 'Next page',
                  previousPageLabel: 'Previous page',
                  pageLabel: pageNumber =>
                    `Page ${pageNumber} of all pages`,
                }}
                currentPageIndex={appStore?.paginationPageNumber || 0}
                onChange={({ detail }) => {
                  appStore?.setCurrentPageIndex(detail.currentPageIndex);
                  if (isFavoritesFolder) {
                    this.props.dbFolderContainerStore?.setFavorites();
                    return;
                  }
                  isSearch ? this.runSearch() : this.getFolders();
                }}
                pagesCount={documentWrapper?.documentMetadata?.totalPages || 1}
                data-testid="dashboard-pagination"
              />
            </SpaceBetween>
            <section id="policy--document-pagination-amount-select-section" data-testid="dashboard-page-size-section">
              <TextContent>
                <small>Items Per Page</small>
              </TextContent>
              <Select
                id="policy--document-pagination-amount-select"
                data-testid="dashboard-page-size-select"
                selectedOption={appStore?.paginationPageSize || { label: '10', value: '10' }}
                onChange={({ detail }) => {
                  appStore?.setPaginationAmount(detail.selectedOption);
                  if (isFavoritesFolder) {
                    this.props.dbFolderContainerStore?.setFavorites();
                    return;
                  }
                  isSearch ? this.runSearch() : this.getFolders();
                }}
                options={[
                  { label: '5', value: '5' },
                  { label: '10', value: '10' },
                  { label: '25', value: '25' },
                ]}
                selectedAriaLabel="Select number of documents per page."
              />
            </section>
          </Grid>
        </section>
      </section>
    );
  }
}